// extracted by mini-css-extract-plugin
export default {"diet_page":"Diet-list_diet_page__qRFzV","diet_head":"Diet-list_diet_head__qMUt4","search_bar":"Diet-list_search_bar__pUcDS"};